import data from './sorpetaler-images.json';

type Thickness<T extends 68 | 78 | 90> = {
  [key in T]: Record<string, SorpetalerImage>;
};

type SorpetalerImageTree = {
  basis: Thickness<68 | 78 | 90>;
  classic: Thickness<68 | 78 | 90>;
  gracil: Thickness<68 | 78>;
  konzept: Thickness<68 | 78>;
  profil: Thickness<68 | 78>;
  reno: Thickness<68 | 78 | 90>;
  linear: Thickness<68 | 78>;
  modern: Thickness<68 | 78>;
};

type SorpetalerImage = {
  id: string;
  imagePath: string;
};

export const SORPETALER_IMAGES = data as SorpetalerImageTree;
